import { jsx as _jsx } from "react/jsx-runtime";
export const InteractiveContainer = ({ children, label, ref, eventMode, ...props }) => {
    return (_jsx("container", { ...props, label: label, sortableChildren: true, ref: ref, eventMode: eventMode, children: children }));
};
//# sourceMappingURL=InteractiveContainer.js.map